import { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { sendQuotePayment } from "utils/api/quote";
import { PaymentFormContext } from "..";
import { useEffectOnce } from "react-use";
import { CircularProgress, Container } from "./styles";

export interface TestProps {
  className?: string;
}

export function Test({ className }: TestProps) {
  const apiCallInitiated = useRef(false);
  const { t } = useTranslation("screens", {
    keyPrefix: "checkout.sections.payment.paymentForm.test",
  });

  const {
    onPaymentComplete,
    onPaymentError,
    onPaymentRequest,
    quoteDto,
    quoteId,
    providerStatus,
  } = useContext(PaymentFormContext);

  useEffectOnce(() => {
    if (!quoteDto || apiCallInitiated.current) {
      return;
    }
    apiCallInitiated.current = true;
    onPaymentRequest?.("test");

    void sendQuotePayment(
      {
        paymentService: "stripe",
        paymentToken: "tok_dummy",
        purchasePaymentType: "PAYMENT_TYPE_CREDIT_CARD",
        quoteId,
      },
      quoteDto,
    )
      .then(onPaymentComplete)
      .catch(onPaymentError);
  });

  if (providerStatus !== "loaded") {
    return null;
  }

  return (
    <Container className={className}>
      <CircularProgress />
      {t("lead")}
    </Container>
  );
}
